/* eslint-disable @typescript-eslint/no-explicit-any */
import { InterpolationData } from '../../models/interpolation/interpolation-data.type';
import { InterpolationValue } from '../../models/interpolation/interpolation-value.type';

export function interpolate<T>(value: T, data: InterpolationData): T;

export function interpolate(value: any, data: InterpolationData): any {
  const interpolationRegExp = new RegExp(
    /{{(\s|&nbsp;)*([\w]*)(\s|&nbsp;)*}}/g,
  );
  const interpolationKeyRegExp = new RegExp(/((\s|&nbsp;)*[{}]+)(\s|&nbsp;)*/g);

  if (Array.isArray(value)) {
    return value.map((_value) => interpolate(_value, data));
  } else if (
    typeof value === 'object' &&
    value !== null &&
    value !== undefined
  ) {
    return Object.keys(value).reduce(
      (interpolated, key: string) => ({
        ...interpolated,
        [key]: interpolate(value[key], data),
      }),
      {},
    );
  } else if (typeof value !== 'string') {
    return value;
  }

  const interpolationMatches: RegExpMatchArray | null =
    value.match(interpolationRegExp);

  if (!interpolationMatches) {
    return value;
  }

  return interpolationMatches.reduce(
    (interpolatedValue: string, interpolationMatch: string) => {
      const interpolationKey: string = interpolationMatch.replace(
        interpolationKeyRegExp,
        '',
      );
      const interpolationValue: InterpolationValue | undefined =
        data && data[interpolationKey];

      if (interpolationValue !== undefined && interpolationValue !== null) {
        return interpolatedValue.replace(
          interpolationMatch,
          interpolationValue.toString(),
        );
      }

      return interpolatedValue.replace(interpolationMatch, '');
    },
    value,
  );
}
